import Client from './HTTPClient';

const API = {
  list (request) {
    return Client.post('/api/mediatypes/', request);
  },

  create (request) {
    return Client.post('/api/mediatypes/new', request);
  }
};

export default API;
